




















import { Component, Vue, Prop } from 'vue-property-decorator'
import OfferCanvas from '@/assets/drawOfferCanvas'

interface OfferType {
  availableShares: number
  __typename: string
  id: string
  closingDate: string
  description: string
  offerName: string
  openingDate: string
  title: string
  totalValue: number
  status: string
  minInvestValue: string
  maxInvestValue: string
  increment: number
  hasActiveMetrics: boolean
  amountOfQuotas: number
  assets: any
  offerImage: null
}

@Component({
  name: 'BlkOfferProgression',
  directives: {
    draw: {
      bind: (canvasElement, binding) => {
        binding.value.draw(canvasElement as HTMLCanvasElement)
      },
      update: (canvasElement, binding) => {
        binding.value.draw(canvasElement as HTMLCanvasElement)
      }
    }
  }
})
export default class RxCanvas extends Vue {
  @Prop(Object) offer!: OfferType

  get percentageSold() {
    const totalShares: number = this.offer.amountOfQuotas
    const availablePercent: number =
      (this.offer.availableShares * 100) / totalShares
    return Math.floor(100 - availablePercent)
  }

  get degrees() {
    return this.percentageSold * 3.6
  }

  get OfferCanvas(): OfferCanvas {
    const color = this.offer.status === 'open' || this.offer.status == 'preopen'
    return new OfferCanvas(this.degrees, color)
  }

  get totalAvailable() {
    const value: number = this.offer.availableShares * this.offer.increment
    if (value >= 1000 && value < 1000000) {
      return (
        Math.floor(value / 1000).toString() +
        this.$t('offers.offerDetails.thousand')
      )
    } else if (value >= 1000000) {
      return (
        (Math.round(value / 100000) / 10).toString().replace('.', ',') + 'MM'
      )
    } else {
      return value
    }
  }

  get totalValue() {
    const value: number = this.offer.totalValue
    if (value >= 1000 && value < 1000000) {
      return (
        Math.floor(value / 1000).toString() +
        this.$t('offers.offerDetails.thousand')
      )
    } else if (value >= 1000000) {
      return (
        (Math.round(value / 100000) / 10).toString().replace('.', ',') + 'MM'
      )
    } else {
      return value
    }
  }

  get cardType() {
    if (this.offer.status.includes('open')) {
      return { text: 'textOpen', percent: 'percentOpen', value: 'valueOpen' }
    } else {
      return {
        text: 'textClosed',
        percent: 'percentClosed',
        value: 'valueClosed'
      }
    }
  }
}
